module.exports = __webpack_public_path__ + "img/chordline-64px.fff1962b.png";